import { useToast } from 'vue-toastification'

export function useToastService() {
  const toast = useToast()

  const success = (title: string, message?: string) => {
    const content = message ? `${title}: ${message}` : title
    toast.success(content, {
      timeout: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnFocusLoss: true,
      pauseOnHover: true,
      draggable: true,
      showCloseButtonOnHover: false,
      closeButton: 'button'
    })
  }

  const error = (title: string, message?: string) => {
    const content = message ? `${title}: ${message}` : title
    toast.error(content, {
      timeout: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnFocusLoss: true,
      pauseOnHover: true,
      draggable: true,
      showCloseButtonOnHover: false,
      closeButton: 'button'
    })
  }

  const warning = (title: string, message?: string) => {
    const content = message ? `${title}: ${message}` : title
    toast.warning(content, {
      timeout: 4000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnFocusLoss: true,
      pauseOnHover: true,
      draggable: true,
      showCloseButtonOnHover: false,
      closeButton: 'button'
    })
  }

  const info = (title: string, message?: string) => {
    const content = message ? `${title}: ${message}` : title
    toast.info(content, {
      timeout: 4000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnFocusLoss: true,
      pauseOnHover: true,
      draggable: true,
      showCloseButtonOnHover: false,
      closeButton: 'button'
    })
  }

  const clear = () => {
    toast.clear()
  }

  return {
    success,
    error,
    warning,
    info,
    clear
  }
}

export default useToastService
